import React from 'react';

function FeedbackCardIcon() {
  return (
    <svg width={24} height={18} fill="none">
      <title>Ilustração de cartão</title>
      <path d="M3.84 5.64a.96.96 0 00-.96.96v.96c0 .53.43.96.96.96h1.92c.53 0 .96-.43.96-.96V6.6a.96.96 0 00-.96-.96H3.84z" fill="#111" />
      <path d="M2.4.84h19.2c1.68 0 2.4.72 2.4 2.4v11.52c0 1.68-.72 2.4-2.4 2.4H2.4c-1.68 0-2.4-.72-2.4-2.4V3.24C0 1.56.72.84 2.4.84zm0 .96C1.25 1.8.96 2.09.96 3.24v11.52c0 1.15.29 1.44 1.44 1.44h19.2c1.15 0 1.44-.29 1.44-1.44V3.24c0-1.15-.29-1.44-1.44-1.44H2.4z" fill="#111" />
    </svg>
  );
}

export default FeedbackCardIcon;
